/**
 * @generated SignedSource<<2a8004fa45eb0b812b77be54fd002799>>
 * @relayHash f30148119addea651a9b8860c7c557f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b33dff432f340c6c68b9ae784353feca7ff3fcc20bd2bcdf7edabe537ad1a7b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_StatisticsSidebarQuery } from './ui_StatisticsSidebarQuery.graphql';

const node: PreloadableConcreteRequest<ui_StatisticsSidebarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7b33dff432f340c6c68b9ae784353feca7ff3fcc20bd2bcdf7edabe537ad1a7b",
    "metadata": {},
    "name": "ui_StatisticsSidebarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
